import { useSubscriptionCRUDActions } from '@mm/state/actions/SubscriptionCRUDActions';
import { ADDON_SETTINGS_KEYS } from '@mm/state/interfaces/subscription';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { Alert } from 'antd';
import React from 'react';

export const useXRayBillingLimit = ({
  subscription,
  onSuccess,
}: {
  subscription: SubscriptionModel | undefined;
  onSuccess?: () => void;
}) => {
  const { openBillingLimitsModal, closeModal } = useModalActions();
  const { update } = useSubscriptionCRUDActions();

  const onUpdateXRayLimit = async (xrayLimit: number | null) => {
    if (subscription && xrayLimit !== subscription.xrayLimit) {
      await update(subscription.id, { xrayLimit });
      onSuccess?.();
      closeModal();
    } else {
      closeModal();
    }
  };

  const updateXRayLimit = () => {
    openBillingLimitsModal({
      title: 'Monthly X-Ray Pixel Capture Limit',
      minValue:
        subscription?.addonUsage?.[ADDON_SETTINGS_KEYS.xrayLeads]?.included ||
        10,
      defaultValue:
        subscription?.addonUsage?.[ADDON_SETTINGS_KEYS.xrayLeads]?.included ||
        subscription?.xrayLimit,
      limitComponent: (
        <Alert
          type="warning"
          closable={false}
          message="X-Ray lead capture will be paused when the limit is reached. 
          Actual capture limit may deviate by 10-15% depending on your capture speed."
          className="billing-page-card__limit-alert"
          showIcon
        />
      ),
      onSubmit: onUpdateXRayLimit,
    });
  };

  return { updateXRayLimit };
};
